import './styles/PageHeader.css';

interface PageHeaderProps {
    title: string;
}

export const PageHeader: React.FC<PageHeaderProps> = ({ title }) => {
    return (
        <div className="page-header">
            <h1 className="page-header-title-text">{title}</h1>
        </div>
    );
};